<mat-expansion-panel [expanded]="true" #panel hideToggle="true" data-test-id="Open Tickets" class="issues-panel">
  <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
    <mat-panel-title class="my-3">
      <h1 class="m-0">Open Tickets</h1>
    </mat-panel-title>
    <mat-panel-description class="justify-content-end flex-grow-0 m-0">
      <mat-icon>{{ panel.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <div class="panel-body">
    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-end mb-2">
          <mat-form-field class="input-normalize">
            <input type="text" matInput [formControl]="formSearch" placeholder="Search" />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        </div>
        <div class="table-content">
          @if (isLoading()) {
            <mat-progress-bar mode="query"></mat-progress-bar>
          }
          <table mat-table matSort [dataSource]="dataList$ | async" class="mat-elevation-z8">
            <!-- Customer Column -->
            <ng-container matColumnDef="customer_name">
              <th
                mat-header-cell
                *matHeaderCellDef
                sortActionDescription="Sort by customer name"
                class="header-border-right fw-semibold"
              >
                Customer
              </th>
              <td mat-cell *matCellDef="let element" class="table-elem-border-right">
                {{ element.customer_name }}
              </td>
            </ng-container>

            <!-- ID Column -->
            <ng-container matColumnDef="zendesk_id">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                sortActionDescription="Sort by zendesk_id"
                class="header-border-right fw-semibold"
              >
                #
              </th>
              <td mat-cell *matCellDef="let element" class="table-elem-border-right">
                {{ element.zendesk_id }}
              </td>
            </ng-container>

            <!-- Title Column -->
            <ng-container matColumnDef="subject">
              <th
                mat-header-cell
                *matHeaderCellDef
                sortActionDescription="Sort by title"
                class="header-border-right fw-semibold"
              >
                Title
              </th>
              <td mat-cell *matCellDef="let element" class="table-elem-border-right text-break-word">
                {{ element.subject }}
              </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="status">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                sortActionDescription="Sort by status"
                class="fw-semibold"
              >
                Status
              </th>
              <td mat-cell *matCellDef="let element" class="status-column">
                <mat-chip-set
                  aria-label="Status"
                  class="status-chip chip-size-m"
                  [ngClass]="element.status | statusColor"
                >
                  <mat-chip>
                    {{ element.status }}
                  </mat-chip>
                </mat-chip-set>
              </td>
            </ng-container>

            <!-- Last updated -->
            <ng-container matColumnDef="updated_at">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                sortActionDescription="Sort by last run"
                class="fw-semibold"
              >
                Last updated
              </th>
              <td mat-cell *matCellDef="let element" class="text-ellipsis">
                {{ element.updated_at }}
              </td>
            </ng-container>

            <!-- Filter row columns -->
            <ng-container matColumnDef="filter_customer_name">
              <th mat-header-cell *matHeaderCellDef class="filter-cell header-border-right">
                <mat-form-field class="filter-field" subscriptSizing="dynamic">
                  <input matInput [formControl]="filterCustomerName" placeholder="Filter..." />
                </mat-form-field>
              </th>
            </ng-container>

            <ng-container matColumnDef="filter_zendesk_id">
              <th mat-header-cell *matHeaderCellDef class="filter-cell header-border-right">
                <mat-form-field class="filter-field" subscriptSizing="dynamic">
                  <input matInput type="number" [formControl]="filterZendeskId" placeholder="Filter..." />
                </mat-form-field>
              </th>
            </ng-container>

            <ng-container matColumnDef="filter_subject">
              <th mat-header-cell *matHeaderCellDef class="filter-cell header-border-right">
                <mat-form-field class="filter-field" subscriptSizing="dynamic">
                  <input matInput [formControl]="filterSubject" placeholder="Filter..." />
                </mat-form-field>
              </th>
            </ng-container>

            <ng-container matColumnDef="filter_status">
              <th mat-header-cell *matHeaderCellDef class="filter-cell">
                <mat-form-field class="filter-field" subscriptSizing="dynamic">
                  <mat-select [formControl]="filterStatus" placeholder="All">
                    <mat-option value="">All</mat-option>
                    @for (s of ticketStatusOptions; track s) {
                      <mat-option [value]="s">{{ s }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </th>
            </ng-container>

            <ng-container matColumnDef="filter_updated_at">
              <th mat-header-cell *matHeaderCellDef class="filter-cell"></th>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-header-row *matHeaderRowDef="filterColumns; sticky: true" class="filter-row"></tr>
            <tr
              mat-row
              class="row-expandable"
              *matRowDef="let row; columns: displayedColumns"
              (click)="navigateToItem(row.url)"
            ></tr>

            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="5">
                @if (isLoading()) {
                  <div class="empty-table">
                    <div class="empty-table-message-info">Loading...</div>
                  </div>
                } @else if ((dataList$ | async)?.data?.length === 0) {
                  <div class="empty-table">
                    <div class="empty-table-message-info">{{ emptyListMessage() }}</div>
                  </div>
                }
              </td>
            </tr>
          </table>
        </div>
        <div class="mt-2 d-flex justify-content-between">
          <button
            mat-button
            color="primary"
            type="button"
            class="action-button mt-2"
            data-test-id="seeMoreBtn"
            (click)="seeMore()"
          >
            See More
          </button>
          <mat-paginator
            [length]="resultsLength()"
            [pageSize]="pageSize()"
            [pageIndex]="currentPage() - 1"
            (page)="onPageChange($event)"
            [pageSizeOptions]="[10, 20, 30]"
            [showFirstLastButtons]="true"
            aria-label="Select page of results"
            class="paginator"
          ></mat-paginator>
        </div>
      </div>
    </div>
  </div>
</mat-expansion-panel>
